"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc721ContractDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const wagmi_1 = require("wagmi");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
const utils_1 = require("./utils");
const Erc721ContractDeployDialog = (props) => {
    const { contractTemplate } = props;
    const { chainId = 0 } = (0, wagmi_1.useAccount)();
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [3, 2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { required: true, name: "name" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { required: true, name: "symbol" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.Erc721ContractTemplates, readOnly: contractTemplate !== types_1.Erc721ContractTemplates.SIMPLE, disabledOptions: (0, utils_1.isTemplateDisabled)(chainId) }), (0, jsx_runtime_1.jsx)(inputs_1.RoyaltyInput, {}), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { required: true, name: "baseTokenURI" })] }));
};
exports.Erc721ContractDeployDialog = Erc721ContractDeployDialog;
//# sourceMappingURL=index.js.map